import React from 'react';
import { Icon } from '@aha/ui';
import { notification } from 'antd';
import { isObject, get } from 'lodash';

export const defaultErrorMessage = 'Fail to fetch';
export const defaultErrorDescription =
  'Cannot fetch data at the moment, please try it later.';

export default function showErrorNotification(
  message: string = defaultErrorMessage,
  error: any = defaultErrorDescription,
) {
  const description = isObject(error)
    ? get(error, 'response.data.Message', '') || get(error, 'message', '')
    : error;

  notification.open({
    className: 'bg-red-lightest border border-red',
    message,
    description,
    icon: <Icon type="times-circle" className="text-red" />,
  });
}
